var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menus & lists/burger-menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f64d4664-052c-44c8-8f82-9731ebf29dd1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01996 18.5C2.01996 18.2349 2.23486 18.02 2.49996 18.02H21.5C21.7651 18.02 21.98 18.2349 21.98 18.5C21.98 18.7651 21.7651 18.98 21.5 18.98H2.49996C2.23486 18.98 2.01996 18.7651 2.01996 18.5Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b8a16f08-c817-4715-9dd0-d6486079041a (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01996 12C2.01996 11.7349 2.23486 11.52 2.49996 11.52H21.5C21.7651 11.52 21.98 11.7349 21.98 12C21.98 12.2651 21.7651 12.48 21.5 12.48H2.49996C2.23486 12.48 2.01996 12.2651 2.01996 12Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7f5d8f7d-18f4-4654-b90d-55fa8ad8f3a2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.01996 5.50002C2.01996 5.23492 2.23486 5.02002 2.49996 5.02002H21.5C21.7651 5.02002 21.98 5.23492 21.98 5.50002C21.98 5.76512 21.7651 5.98002 21.5 5.98002H2.49996C2.23486 5.98002 2.01996 5.76512 2.01996 5.50002Z",
    fill: "#08081B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.9d0232d9ca8308951877724b33a89dd6.svg";
export { ForwardRef as ReactComponent };